import {
    HttpGetCarrierGroup,
    HttpGetAllCarrierService,
} from "@/service/carrieraccount.js";
export default {
    data() {
        return {
            carrierGroupList:[],
            carrierServiceList:[],
        }
    },
    created(){
        this.getCarrierGroupList();
    },
    computed: {
        getCarrierStatus () {
            return [
                {
                    label: 'active',
                    value: 1
                },
                {
                    label: 'inActive',
                    value: 0
                }
            ]
        }
    },
    methods:{
        async getCarrierGroupList() {
            await HttpGetCarrierGroup().then(
                (res) => {
                    this.carrierGroupList = res.data.map((item) => {
                        return {
                            label: item.groupName,
                            value: item.id,
                            attach: {
                                ...item,
                            },
                        };
                    });
                },
                (err) => {
                    this.$VMessage.error(err.message);
                }
            );
            HttpGetAllCarrierService().then(res => {
                this.carrierServiceList = res.data.map(item => {
                    return {
                        label: `${item.carrierServiceName}(${item.carrierServiceCode})`,
                        value: item.id,
                        attach:{
                            carrierServiceCode:item.carrierServiceCode
                        }
                    }
                });
            }, err => {
                this.$VMessage.error(err.message);
            });
        },
        
    }
}